import { render } from "./index.vue?vue&type=template&id=58aa0bb8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=58aa0bb8&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=58aa0bb8&lang=scss"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58aa0bb8"]])

export default __exports__